import React from 'react';
import { Box } from '@mui/material';
import TrendingSidebar from './TrendingSidebar/TrendingSidebar';

/**
 * TRENDINGASIDE — desktop sidebar widgets (320px).
 *
 * Thin adapter that lives inside the AppShell `aside` grid area and
 * renders the existing `TrendingSidebar` in flow-layout mode. The
 * legacy `TrendingSidebar` historically used `position: fixed` and
 * self-gated on `useMediaQuery('lg')`, which collided with centered
 * content and caused the mobile overflow bugs. Passing `inFlow` drops
 * both behaviors — the CSS grid handles hiding the column on small
 * viewports, and sticky positioning replaces the fixed positioning.
 */
const TrendingAside: React.FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <TrendingSidebar inFlow />
    </Box>
  );
};

export default TrendingAside;
